import { s } from '../lib/style.js';

export function Security({ v }) {
  return (
    <section
      id="security"
      style={s("scroll-margin-top:80px;position:relative;overflow:hidden;background:#0B1F23;color:#EAF3F1;")}
    >
      <div
        aria-hidden="true"
        style={s("position:absolute;inset:0;pointer-events:none;background:radial-gradient(120% 90% at 15% 0%,rgba(46,122,114,0.30),transparent 60%),radial-gradient(90% 80% at 92% 100%,rgba(91,154,150,0.20),transparent 62%);")}
      />
      <div
        aria-hidden="true"
        style={s("position:absolute;inset:0;pointer-events:none;opacity:.6;background-image:radial-gradient(rgba(255,255,255,0.16) 1px,transparent 1px);background-size:22px 22px;mask-image:radial-gradient(75% 65% at 50% 40%,#000 30%,transparent 100%);-webkit-mask-image:radial-gradient(75% 65% at 50% 40%,#000 30%,transparent 100%);")}
      />
      <div
        style={s("position:relative;z-index:1;max-width:1220px;margin:0 auto;padding:clamp(28px,3vw,44px) clamp(20px,4vw,28px) clamp(40px,5vw,64px);")}
      >
        <div style={s("max-width:720px;")}>
          <div
            style={s("display:inline-flex;align-items:center;margin-bottom:18px;padding:9px 20px;border-radius:999px;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.18);box-shadow:0 2px 10px rgba(0,0,0,0.18);font-family:var(--mono);font-weight:var(--mono-w);font-size:13.5px;letter-spacing:0.14em;text-transform:uppercase;color:#7ACEC0;")}
          >
            Data, security & trust
          </div>
          <h2
            style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:clamp(30px,4vw,50px);line-height:1.08;letter-spacing:-0.03em;margin:0;color:#FFFFFF;")}
          >
            Your data
            {' '}
            <span style={s(v.kwDark)}>
              stays yours.
            </span>
          </h2>
          <p style={s("margin:20px 0 0;font-size:18px;line-height:1.65;color:rgba(234,243,241,0.68);")}>
            We'll walk your security and IT stakeholders through our full data-governance posture during onboarding, and confirm exact terms in writing.
          </p>
        </div>
        <div
          style={s("display:grid;grid-template-columns:repeat(auto-fit,minmax(min(230px,100%),1fr));margin-top:clamp(40px,4.5vw,60px);")}
        >
          <div
            className="hv-12"
            style={s("padding:clamp(30px,3vw,40px) clamp(22px,2.2vw,30px);transition:background .3s ease;")}
          >
            <div
              style={s("width:54px;height:54px;border-radius:15px;background:linear-gradient(150deg,#5B9A96 0%,#1B4A48 100%);box-shadow:0 10px 26px rgba(18,49,56,0.40);display:flex;align-items:center;justify-content:center;color:#EAF3F1;")}
            >
              {' '}
              <svg
                width="34"
                height="34"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.55"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                {' '}
                <path d="M12 3l7 3v6c0 4.2-2.9 7.8-7 9-4.1-1.2-7-4.8-7-9V6z" />
                {' '}
                <path d="M9 12l2.2 2.2L15.5 10" />
                {' '}
              </svg>
              {' '}
            </div>
            <div
              style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:20px;letter-spacing:-0.02em;color:#FFFFFF;margin-top:26px;")}
            >
              Isolated per client
            </div>
            <p
              style={s("margin:13px 0 0;font-size:16.5px;line-height:1.68;color:rgba(234,243,241,0.62);max-width:380px;")}
            >
              Your data is handled and kept isolated per client — never pooled or used to train shared models.
            </p>
          </div>
          <div
            className="hv-12"
            style={s("padding:clamp(30px,3vw,40px) clamp(22px,2.2vw,30px);border-left:1px solid rgba(255,255,255,0.09);transition:background .3s ease;")}
          >
            <div
              style={s("width:54px;height:54px;border-radius:15px;background:linear-gradient(150deg,#5B9A96 0%,#1B4A48 100%);box-shadow:0 10px 26px rgba(18,49,56,0.40);display:flex;align-items:center;justify-content:center;color:#EAF3F1;")}
            >
              {' '}
              <svg
                width="34"
                height="34"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.55"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                {' '}
                <circle cx="12" cy="12" r="9" />
                {' '}
                <path d="M3 12h18" />
                {' '}
                <path d="M12 3c2.8 3 2.8 15 0 18-2.8-3-2.8-15 0-18z" />
                {' '}
              </svg>
              {' '}
            </div>
            <div
              style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:20px;letter-spacing:-0.02em;color:#FFFFFF;margin-top:26px;")}
            >
              Syndicated data, respected
            </div>
            <p
              style={s("margin:13px 0 0;font-size:16.5px;line-height:1.68;color:rgba(234,243,241,0.62);max-width:380px;")}
            >
              Sources like NielsenIQ and Circana are used strictly within your licensing terms.
            </p>
          </div>
          <div
            className="hv-12"
            style={s("padding:clamp(30px,3vw,40px) clamp(22px,2.2vw,30px);border-left:1px solid rgba(255,255,255,0.09);transition:background .3s ease;")}
          >
            <div
              style={s("width:54px;height:54px;border-radius:15px;background:linear-gradient(150deg,#5B9A96 0%,#1B4A48 100%);box-shadow:0 10px 26px rgba(18,49,56,0.40);display:flex;align-items:center;justify-content:center;color:#EAF3F1;")}
            >
              {' '}
              <svg
                width="34"
                height="34"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.55"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                {' '}
                <rect x="4" y="10.5" width="16" height="10.5" rx="2.5" />
                {' '}
                <path d="M8 10.5V8a4 4 0 018 0v2.5" />
                {' '}
                <path d="M12 14.5v2.5" />
                {' '}
              </svg>
              {' '}
            </div>
            <div
              style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:20px;letter-spacing:-0.02em;color:#FFFFFF;margin-top:26px;")}
            >
              Private by default
            </div>
            <p
              style={s("margin:13px 0 0;font-size:16.5px;line-height:1.68;color:rgba(234,243,241,0.62);max-width:380px;")}
            >
              Encryption in transit and at rest, with strict access controls on every connector.
            </p>
          </div>
          <div
            className="hv-12"
            style={s("padding:clamp(30px,3vw,40px) clamp(22px,2.2vw,30px);border-left:1px solid rgba(255,255,255,0.09);transition:background .3s ease;")}
          >
            <div
              style={s("width:54px;height:54px;border-radius:15px;background:linear-gradient(150deg,#5B9A96 0%,#1B4A48 100%);box-shadow:0 10px 26px rgba(18,49,56,0.40);display:flex;align-items:center;justify-content:center;color:#EAF3F1;")}
            >
              {' '}
              <svg
                width="34"
                height="34"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.55"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                {' '}
                <rect x="6" y="6" width="12" height="12" rx="2.5" />
                {' '}
                <rect x="9.5" y="9.5" width="5" height="5" rx="1" />
                {' '}
                <path d="M9 3v3M15 3v3M9 18v3M15 18v3M3 9h3M3 15h3M18 9h3M18 15h3" />
                {' '}
              </svg>
              {' '}
            </div>
            <div
              style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:20px;letter-spacing:-0.02em;color:#FFFFFF;margin-top:26px;")}
            >
              A serious posture, maturing fast
            </div>
            <p
              style={s("margin:13px 0 0;font-size:16.5px;line-height:1.68;color:rgba(234,243,241,0.62);max-width:380px;")}
            >
              We're pursuing SOC 2 and data-provider partner approvals as we scale with our founding partners.
            </p>
          </div>
        </div>
        <div style={s("margin-top:34px;")}>
          {' '}
          <a
            className="hv-13"
            href="mailto:hello@getbrandbase.com?subject=Security%20overview%20request"
            style={s("text-decoration:none;display:inline-flex;align-items:center;gap:9px;color:#7ACEC0;font-size:16.5px;font-weight:600;")}
          >
            Request our security overview
            {' '}
            <span style={s("font-size:18px;")}>
              →
            </span>
          </a>
          {' '}
        </div>
      </div>
    </section>
  );
}
